import { configureStore } from "@reduxjs/toolkit";
import userSlice from "../../Redux/reducer/reducer";
export const store = configureStore({ reducer: { user: userSlice } });